import { connect } from 'react-redux';
import MessageCreatorComponent from '../components/message_creator';
import MessageCreatorActions from '../actions/message_creator';

function mapStateToProps(state) {
  return {
    activeConversation: state.activeConversation.id || '',
    url: '/conversations/' + state.activeConversation.id + '/messages',
    disabled: state.messageCreator.disabled,
    errors: state.messageCreator.errors,
    height: state.messageCreator.height,
    conversationDetailsVisible: state.conversationDetails.visible
  };
}

const MessageCreatorContainer = connect(
  mapStateToProps,
  {
    persistMessage: MessageCreatorActions.persist,
    setHeight: MessageCreatorActions.setHeight
  }
)(MessageCreatorComponent);

export default MessageCreatorContainer;
